/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { DropdownOption } from '@/components/cards/types';

import { Audit, AuditError } from '@/pages/audit_setup_wizard/types';

export interface State {
  audit: Audit;
  auditOriginalState?: Audit;
  auditError: AuditError;
  currentStep: number;
  isLoading: boolean;
  isSaving: boolean;
  jiraEnabled: boolean;
  servicenowEnabled: boolean;
  storageIntegrationEnabled: boolean;
  flagNewTicketing: boolean;
  syncExternalComments: boolean;
  syncExternalAttachments: boolean;
  jiraBus: {
    title: string;
    initialJiraData: object;
    jiraData: object;
  };
  performingAssessment: boolean;
  templateAssessors: DropdownOption[];
  templateVerifiers: DropdownOption[];
  isRequestMapperVisible: boolean;
  remoteRequests: object[];
}

export const initAuditState: Audit = {
  id: -1,
  title: '',
  status: '',
  startDate: '',
  endDate: '',
  reportStartDate: '',
  reportEndDate: '',
  managedIn: {
    label: 'ZenGRC',
    value: 'ZENGRC',
  },
  jira: null,
  storage: null,
  auditors: [],
  auditManagers: [],
  relatedProgram: {},
  assessmentTemplate: {},
  mappedAssessments: [],
  mappedControls: [],
  mappedRequests: [],
  syncExternalComments: false,
  syncExternalAttachments: false,
};

export default (): State => ({
  audit: initAuditState,
  auditError: {
    title: [],
    type: [],
    status: [],
    startDate: [],
    endDate: [],
    reportStartDate: [],
    reportEndDate: [],
    managedIn: [],
    jira: [],
    auditors: [],
    auditManagers: [],
    relatedProgram: [],
    auditFirm: [],
  },
  currentStep: 1,
  isLoading: false,
  isSaving: false,
  jiraEnabled: false,
  flagNewTicketing: false,
  servicenowEnabled: false,
  storageIntegrationEnabled: false,
  jiraBus: {
    title: '',
    initialJiraData: {},
    jiraData: {},
  },
  performingAssessment: true,
  templateAssessors: [],
  templateVerifiers: [],
  isRequestMapperVisible: false,
  remoteRequests: [],
});
